import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import { DropdownOption } from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var variantSchema = {
    name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    body: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Коментар *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден коментар',
    }),
    rating: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [
                new DropdownOption({ label: '1', value: '1' }),
                new DropdownOption({ label: '2', value: '2' }),
                new DropdownOption({ label: '3', value: '3' }),
                new DropdownOption({ label: '4', value: '4' }),
                new DropdownOption({ label: '5', value: '5' }),
            ],
        }),
        elementType: 'dropdown',
        label: 'Рейтинг *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден рейтинг',
    }),
    approved: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'checkbox',
        label: 'Одобрено',
        value: false,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Трябва да бъде селектирано',
    }),
    created_at: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
            readOnlyInput: true
        }),
        elementType: 'input',
        label: 'Създаден на',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна дата',
    }),
    user_email: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
            readOnlyInput: true
        }),
        elementType: 'input',
        label: 'E-mail на потребителя',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден E-mail',
    }),
    product_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
            readOnlyInput: true
        }),
        elementType: 'input',
        label: 'Име на продукта',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на продукт',
    }),
};
export default variantSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/reviewSchema.ts
// module id = 436
// module chunks = 0